<template>
  <div
    class="d-flex align-center justify-space-between pa-6 header-container"
  >
    <div class="d-flex align-center justify-start">
      <h5 class="label">
        {{ tableLabel }}
      </h5>
    </div>
    <DpplNewButton
      v-if="documents.length && !disableShare"
      :color="disabled ? 'grey600' : 'brandPrimary'"
      :disabled="disabled"
      @click="$emit('share')"
    >
      Share Jobs
      <v-icon icon="material-symbols:share-outline" class="ml-2" color="iconWhite" />
    </DpplNewButton>
  </div>
</template>

<script>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

export default {
  name: 'TableContentHeader',
  components: {
    DpplNewButton,
  },
  props: {
    documents: {
      type: Array,
      default() {
        return [];
      },
    },
    tableLabel: {
      type: String,
      default: '',
    },
    selectedJobs: {
      type: Array,
      default() {
        return [];
      },
    },
    disableShare: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['share'],
  computed: {
    disabled() {
      return !this.selectedJobs.length || this.disableShare;
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  background: @white;
  height: 76px;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid @stroke-default;
}
</style>
